import React from "react";

const AppML_HowTo = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML HowTo</h1>
      <p>This is the AppML HowTo page content.</p>
    </div>
  );
};

export default AppML_HowTo;
